import { createAsyncThunk } from "@reduxjs/toolkit"
import { del, formDataPost, formDataPut, patch, post, put } from "helpers/api_helper"
import { OFFER_BANNER_CONFIG } from "constants/bannerModuleConfig"

const api = OFFER_BANNER_CONFIG.api

export const getAllOfferBanners = createAsyncThunk(api.list, async payload => {
  const response = await post(api.list, payload)
  return response
})

export const addOfferBanner = createAsyncThunk(api.add, async payload => {
  const response = await post(api.add, payload)
  return response
})

export const deleteOfferBanner = createAsyncThunk(api.delete, async payload => {
  const response = await del(api.delete, payload)
  return response
})

export const getOfferBannerDetails = createAsyncThunk(
  api.details,
  async payload => {
    const response = await post(api.details, payload)
    return response
  }
)

export const updateOfferBanner = createAsyncThunk(api.update, async payload => {
  const response = await put(api.update, payload)
  return response
})

export const updateOfferBannerStatus = createAsyncThunk(
  api.updateStatus,
  async payload => {
    const response = await patch(api.updateStatus, payload)
    return response
  }
)

export const getOfferSlideDetails = createAsyncThunk(
  api.slideDetails,
  async payload => {
    const response = await post(api.slideDetails, payload)
    return response
  }
)

export const updateOfferSlideStatus = createAsyncThunk(
  api.slideUpdateStatus,
  async payload => {
    const req = { id: payload.id, status: payload.status }
    const response = await patch(api.slideUpdateStatus, req)
    return response
  }
)

export const deleteOfferSlide = createAsyncThunk(api.slideDelete, async payload => {
  const req = { id: payload.id, status: payload.status }
  const response = await del(api.slideDelete, req)
  return response
})

export const addOfferSlide = createAsyncThunk(api.slideAdd, async payload => {
  const response = await formDataPost(api.slideAdd, payload)
  return response
})

export const updateOfferSlide = createAsyncThunk(api.slideUpdate, async payload => {
  const response = await formDataPut(api.slideUpdate, payload)
  return response
})
